/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var MessageDirection;
(function (MessageDirection) {
    MessageDirection["INBOUND"] = "INBOUND";
    MessageDirection["OUTBOUND"] = "OUTBOUND";
})(MessageDirection || (MessageDirection = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var MessageOrigin;
(function (MessageOrigin) {
    MessageOrigin["PRIVATE_INBOX"] = "PRIVATE_INBOX";
    MessageOrigin["SHARED_INBOX"] = "SHARED_INBOX";
    MessageOrigin["ENGAGEMENT_CAMPAIGN"] = "ENGAGEMENT_CAMPAIGN";
})(MessageOrigin || (MessageOrigin = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var ChatAssistantAvatarType;
(function (ChatAssistantAvatarType) {
    ChatAssistantAvatarType["GENERIC"] = "GENERIC";
    ChatAssistantAvatarType["CUSTOM"] = "CUSTOM";
})(ChatAssistantAvatarType || (ChatAssistantAvatarType = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var ConversationSource;
(function (ConversationSource) {
    ConversationSource["SMS"] = "SMS";
    ConversationSource["WEB_CHAT"] = "WEB_CHAT";
    ConversationSource["FACEBOOK"] = "FACEBOOK";
    ConversationSource["INSTAGRAM"] = "INSTAGRAM";
})(ConversationSource || (ConversationSource = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var Rating;
(function (Rating) {
    Rating["POSITIVE"] = "POSITIVE";
    Rating["NEGATIVE"] = "NEGATIVE";
})(Rating || (Rating = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isCampaignMessageEvent = (event) => (event === null || event === void 0 ? void 0 : event.type) === 'CAMPAIGN_MESSAGE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isMessageEvent = (event) => event && !!event['direction'] && !isCampaignMessageEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isAssignEvent = (event) => !!event['assignedTo'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isUnassignEvent = (event) => !!event['unassignedFrom'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isResolveEvent = (event) => !!event['reason'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isCallEvent = (event) => event['type'] === 'CONVERSATION_FLIP_TO_CALL';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isMeetingEvent = (event) => !!event['meetingId'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isCobrowseStartedEvent = (event) => !!event['sessionPin'] && !!event['serviceUrl'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isParticipantLeftEvent = (event) => event['type'] === 'PARTICIPANT_LEFT_CONVERSATION';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatEndedEvent = (event) => event['type'] === 'WEB_CHAT_ENDED';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyInitializedEvent = (event) => (event === null || event === void 0 ? void 0 : event['type']) === 'SURVEY_RATING_QUESTION';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyRatingResponseEvent = (event) => (event === null || event === void 0 ? void 0 : event['type']) === 'SURVEY_RATING_RESPONSE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyFeedbackQuestionEvent = (event) => (event === null || event === void 0 ? void 0 : event['type']) === 'SURVEY_FEEDBACK_QUESTION';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyFeedbackResponseEvent = (event) => (event === null || event === void 0 ? void 0 : event['type']) === 'SURVEY_FEEDBACK_RESPONSE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isFlowSelectNodeResponseEvent = (event) => event['type'] === 'FLOW_SELECT_NODE_RESPONSE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isFlowSendMessageEvent = (event) => event['type'] === 'FLOW_SEND_MESSAGE_NODE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isFlowSendToAgentEvent = (event) => event['type'] === 'FLOW_SEND_TO_AGENT_NODE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isFlowEvent = (event) => isFlowSelectNodeResponseEvent(event) ||
    isFlowSendMessageEvent(event) ||
    isFlowSendToAgentEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyRatingEvent = (event) => isSurveyInitializedEvent(event) || isSurveyRatingResponseEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyFeedbackEvent = (event) => isSurveyFeedbackQuestionEvent(event) || isSurveyFeedbackResponseEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isSurveyEvent = (event) => isSurveyFeedbackEvent(event) || isSurveyRatingEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatAfterHoursEvent = (event) => !event['scheduleId'] && !!event['afterHoursMessage'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isAgentAfterHoursEvent = (event) => !!event['scheduleId'] && !!event['afterHoursMessage'];
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const PENDING_MESSAGE_PREFIX = 'pending';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const FAILED_MESSAGE_PREFIX = 'failed';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var ParticipantHistoryType;
(function (ParticipantHistoryType) {
    ParticipantHistoryType["CALL"] = "CALL";
    ParticipantHistoryType["CHAT"] = "CHAT";
    ParticipantHistoryType["CHAT_PRIVATE_INBOX"] = "CHAT_PRIVATE_INBOX";
})(ParticipantHistoryType || (ParticipantHistoryType = {}));
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export var ConversationResolutionReason;
(function (ConversationResolutionReason) {
    ConversationResolutionReason["RESOLVED"] = "RESOLVED";
    ConversationResolutionReason["RESOLVED_BY_ADMIN"] = "RESOLVED_BY_ADMIN";
    ConversationResolutionReason["SPAM"] = "SPAM";
    ConversationResolutionReason["NO_ACTIVITY"] = "NO_ACTIVITY";
    ConversationResolutionReason["CHAT_QUEUE_DELETED"] = "CHAT_QUEUE_DELETED";
    ConversationResolutionReason["SOURCE_DISABLED"] = "SOURCE_DISABLED";
})(ConversationResolutionReason || (ConversationResolutionReason = {}));
//# sourceMappingURL=types.js.map